import { Component } from '@angular/core';

@Component({
  selector: 'app-table-loader',
  templateUrl: './table-loader.component.html',
  styleUrls: ['./table-loader.component.scss'],
  standalone: false,
})
export class TableLoaderComponent {
  constructor() {}
}
